$( document ).ready(function() {


//service slider
  $('#serviceslider').slick({
  centerMode: true,
  arrows:false,
  infinite: true,
  centerPadding: '0px',
  slidesToShow: 3,
  prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="11" height="18" viewBox="0 0 11 18" fill="none"><path d="M3.9195 8.82025L10.78 15.6808L8.82025 17.6405L0 8.82025L8.82025 0L10.78 1.95975L3.9195 8.82025Z" fill="#BEBEBE"/></svg></button>',
  nextArrow:'<button type="button" class="slick-next pull-right"><svg width="11" height="18" viewBox="0 0 11 18" fill="none"><path d="M6.86053 8.82025L2.99377e-05 15.6808L1.95978 17.6405L10.78 8.82025L1.95978 0L2.99377e-05 1.95975L6.86053 8.82025Z" fill="#BEBEBE"/></svg></button>',
   centerMode: true,
    centerPadding:'80px',
          autoplay:false,
                responsive: [
                {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                    arrows:true,
                }
                },
                {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                  arrows:true,
                }
                },
                {
                breakpoint: 576,
                settings: {
                    slidesToShow: 1,
                    arrows:true,
                    centerPadding:'50px',
                }
                }
            ]
});

  
    //Brand Logo Slider JS
    $('.brand_slick').slick({
            dots: false,
            infinite: false,
            speed: 900,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            autoplay:true,
            autoplaySpeed: 1000,
            arrows: true,
            prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="11" height="18" viewBox="0 0 11 18" fill="none"><path d="M3.9195 8.82025L10.78 15.6808L8.82025 17.6405L0 8.82025L8.82025 0L10.78 1.95975L3.9195 8.82025Z" fill="#BEBEBE"/></svg></button>',
            nextArrow:'<button type="button" class="slick-next pull-right"><svg width="11" height="18" viewBox="0 0 11 18" fill="none"><path d="M6.86053 8.82025L2.99377e-05 15.6808L1.95978 17.6405L10.78 8.82025L1.95978 0L2.99377e-05 1.95975L6.86053 8.82025Z" fill="#BEBEBE"/></svg></button>',
            responsive: [
                {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                }
                },
                {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    autoplay:true,
                }
                },
            ]
            });

            //Home Colletion Slider JS
            $('.home_coll_slick').slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    infinite: true,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: true,
                    prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="11" height="18" viewBox="0 0 11 18" fill="none"><path d="M3.9195 8.82025L10.78 15.6808L8.82025 17.6405L0 8.82025L8.82025 0L10.78 1.95975L3.9195 8.82025Z" fill="#BEBEBE"/></svg></button>',
                    nextArrow:'<button type="button" class="slick-next pull-right"><svg width="11" height="18" viewBox="0 0 11 18" fill="none"><path d="M6.86053 8.82025L2.99377e-05 15.6808L1.95978 17.6405L10.78 8.82025L1.95978 0L2.99377e-05 1.95975L6.86053 8.82025Z" fill="#BEBEBE"/></svg></button>',
                    responsive: [
                       
                        {
                        breakpoint: 400,
                        settings: {
                            slidesToShow: 1,
                           
                        }
                        },
                    ]
                    });

      //featured_collection_slider
            $('.featured_collection_slider').slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    infinite: true,
                    slidesToShow: 2,
                	rows: 2,
                    slidesToScroll: 1,
                    arrows: true,
                    prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="11" height="18" viewBox="0 0 11 18" fill="none"><path d="M3.9195 8.82025L10.78 15.6808L8.82025 17.6405L0 8.82025L8.82025 0L10.78 1.95975L3.9195 8.82025Z" fill="#BEBEBE"/></svg></button>',
                    nextArrow:'<button type="button" class="slick-next pull-right"><svg width="11" height="18" viewBox="0 0 11 18" fill="none"><path d="M6.86053 8.82025L2.99377e-05 15.6808L1.95978 17.6405L10.78 8.82025L1.95978 0L2.99377e-05 1.95975L6.86053 8.82025Z" fill="#BEBEBE"/></svg></button>',
                    responsive: [
                       
                        {
                        breakpoint: 400,
                        settings: {
                            slidesToShow: 1,
                           
                        }
                        },
                    ]
                    });

   //featured_collection_slider_sellers
            $('.featured_collection_slider_sellers').slick({
                    dots: false,
                    infinite: false,
                    speed: 300,
                    infinite: true,
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: true,
                    prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="11" height="18" viewBox="0 0 11 18" fill="none"><path d="M3.9195 8.82025L10.78 15.6808L8.82025 17.6405L0 8.82025L8.82025 0L10.78 1.95975L3.9195 8.82025Z" fill="#BEBEBE"/></svg></button>',
                    nextArrow:'<button type="button" class="slick-next pull-right"><svg width="11" height="18" viewBox="0 0 11 18" fill="none"><path d="M6.86053 8.82025L2.99377e-05 15.6808L1.95978 17.6405L10.78 8.82025L1.95978 0L2.99377e-05 1.95975L6.86053 8.82025Z" fill="#BEBEBE"/></svg></button>',
                    responsive: [
                        {
                          breakpoint: 1199,
                          settings: {
                              slidesToShow: 3,
                             
                          }
                        },
                      {
                          breakpoint: 991,
                          settings: {
                              slidesToShow: 2,
                             
                          }
                        },
                      {
                          breakpoint: 400,
                          settings: {
                              slidesToShow: 1,
                             
                          }
                        },
                    ]
                    });

  /**** Product color varaints widget carousel ****/
  if($('#product_color_variants_widget .widget-wrapper .grid-product').length) {
    $('#product_color_variants_widget').removeClass('hide');
    $('#product_color_variants_widget .widget-wrapper').slick({
      dots: false,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      rows: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow:'<button type="button" class="slick-prev pull-left"><svg width="11" height="18" viewBox="0 0 11 18" fill="none"><path d="M3.9195 8.82025L10.78 15.6808L8.82025 17.6405L0 8.82025L8.82025 0L10.78 1.95975L3.9195 8.82025Z" fill="#BEBEBE"/></svg></button>',
      nextArrow:'<button type="button" class="slick-next pull-right"><svg width="11" height="18" viewBox="0 0 11 18" fill="none"><path d="M6.86053 8.82025L2.99377e-05 15.6808L1.95978 17.6405L10.78 8.82025L1.95978 0L2.99377e-05 1.95975L6.86053 8.82025Z" fill="#BEBEBE"/></svg></button>',
      responsive: [
        {
          breakpoint: 400,
          settings: {
              slidesToShow: 2,
          }
        },
      ]
    });
  }
  
});